/**
 * Check if a sort field is a custom metric
 * @param sortBy - The sort field name to check (e.g., "custom_SHOT_STOPPING" or "name")
 * @returns True if the sort field starts with "custom_" prefix
 */
export const isCustomMetricSort = (sortBy: string): boolean => {
  return sortBy.startsWith("custom_");
};

/**
 * Extract the custom metric ID from a sort field
 * @param customSortField - e.g., "custom_SHOT_STOPPING"
 * @returns The metric ID - e.g., "SHOT_STOPPING"
 */
export const extractCustomMetricId = (customSortField: string): string => {
  return customSortField.replace("custom_", "");
};
